
<div *ngIf="loadingspinner == true" class="spin"></div>


<fieldset [disabled]="loadingspinner == true" [ngClass]="{'disabled':loadingspinner == true}">
  <div class="d-flex flex-wrap" *ngIf="token">
    <div class="two-card common-padding pay-money shadow">
      <button class="btn btn-primary" style="float: right;" (click)="Back()">Back</button>
      &nbsp;
      <h2 class="heading">Make Payment Request</h2>
      <div class="row no-gutters">
        <div class="col-12">
          <div class="row no-gutters">
            <div class="col-md-12">
              <div class="add-balance">
                <div class="ctl-inner">
                  <span class="crtl icon-add_money_1"></span>
                </div>
                <div>
                  <span class="bal-txt">Balance</span>
                  <span class="bal_amount">{{UsertBal.currentBalance}} {{UsertBal.currency}}</span>
                </div>
              </div>
            </div>
            <div class="col-md-12 form-padding">
              <form class="example-form" [formGroup]="payMoneyForm" (ngSubmit)="payMoney(payMoneyForm.value)">


                <div class="row no-gutters">

                  <div class="col-12">
                    <mat-form-field>
                      <mat-label>Select Country</mat-label>
                      <mat-select formControlName="ISD" matTooltip="Select Country" autocomplete="off" required>
                        <mat-form-field>
                          <input matInput [formControl]="CountryFilterCtrl" placeholder="Search Country" />
                        </mat-form-field>

                        <mat-option *ngFor="let d of filterCountry(); let i=index" [value]="d.isdCode">
                          <img matSuffix [src]="d?.countryFlag" style="height: 20px;width: 20px;" />
                          {{d?.name}}({{d?.isdCode}})
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="submitted && f.ISD?.errors?.required">
                        Select Country
                      </mat-error>
                    </mat-form-field>

                  </div>


                  <div class="col-12">
                    <mat-form-field class="example-full-width input-tel">
                      <input type="tel" matInput placeholder="Enter Mobile No. (eg:244476305)"
                             formControlName="MobileMoneySource" Numberonly minlength="8" maxlength="20" required />
                      <mat-error *ngIf="submitted && f.MobileMoneySource?.errors?.required">
                        Mobile No. is required
                      </mat-error>
                      <mat-error *ngIf="f.MobileMoneySource?.errors?.maxlength">
                        Maximum Length Mobile No. is 20
                      </mat-error>

                      <mat-error *ngIf="f.MobileMoneySource?.errors?.minlength">
                        Minimum Length Mobile No. is 8
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field class="example-full-width mb-0">
                      <input matInput placeholder="Enter Amount in USD(eg:100 or eg:0.00)"
                             formControlName="Amount" Numberonly maxlength="9" required>
                      <mat-error *ngIf="submitted && f.Amount?.errors?.required">
                        Amount is required
                      </mat-error>
                    </mat-form-field>
                    <div class="row payable-amount justify-content-around align-items-center mb-4 mt-0">
                      <div class="col-6" *ngIf="amt">

                        <p>Fee({{UsertBal.currency}})</p>
                        <p>{{commissionFee|number}}</p>
                      </div>
                      <div class="col-6 text-right" *ngIf="amt">
                        <p>Net Payable({{UsertBal.currency}})</p>
                        <p>{{commissionTotal|number}}</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-12">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Beneficiary Name" formControlName="BeneficiaryName"
                             maxlength="20" />

                      <mat-error *ngIf="f.BeneficiaryName?.errors?.pattern">
                        Enter Alphabet character
                      </mat-error>

                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Account Description (eg:Kofi's account)"
                             formControlName="Comment" maxlength="200" />
                    </mat-form-field>
                  </div>
                  <div class="col-12">
                    <button type="submit" class="primary-btn">
                      Make Request
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="col-12 mt-4">
          <div class="pay-detail text-center">
            <div class="icon_wrap">
              <i class="icon-payment_secure"></i>
            </div>
            <span class="ng-binding">Your payment details are secured</span>
          </div>
        </div>
      </div>



    </div>


    <div class="two-card recent-card common-padding pay-money shadow overflow-auto">
      <h2 class="heading recent-head">Recent Transaction</h2>
      <table class="table table-hover text-center  table-bordered">
        <thead>
          <tr>
            <th>Service Name</th>

            <th>Mobile No.</th>
            <th>Amount</th>
            <th>Transaction Status</th>
          </tr>
        </thead>

        <tbody *ngFor="let x of userorderdetailList; let i=index">
          <tr *ngIf="i<10">
            <td>
              {{x.serviceName}}
            </td>

            <td>{{x.destination}}</td>
            <td>{{x.amount}}</td>
            <td>{{x.transactionRemark}}</td>
          </tr>
        </tbody>
      </table>


    </div>
  </div>
</fieldset>
